// extracted by mini-css-extract-plugin
export default {"crumbs":"Pagination_crumbs__PCQ8U","crumb":"Pagination_crumb__D9VpY","crumb__active":"Pagination_crumb__active__WbALW","nav":"Pagination_nav__TvNJ1"};